import log from '../utils/log'

export class BikeHubFormValidator {
  init () {
    const self = this

    $('form.jsValidated').on('submit', e => {
      const $form = $(e.target)

      $form.find('.formErrors').collapse('hide')
      const formErrors = self.formValidationErrors($form)
      if (formErrors.length == 0) {
        return true
      }
      self.renderFormErrors($form, formErrors)
      $('html, body').animate({ scrollTop: $form.offset().top - 20 }, 'fast')
      return false
    })
  }

  phoneNumberErrors ($form) {
    const validatedField = $form.find('.validatedPhoneField')
    if (validatedField.length) {
      let enteredNumber = validatedField.val().match(/\d/g)
      enteredNumber =
        enteredNumber == null ? '' : enteredNumber.join('').replace(/^1+/, '')
      if (enteredNumber.length === 0 && window.inAdmin) {
        return null // Staff is permitted to submit blank phone numbers
      }
      if (enteredNumber.length !== 10) {
        return 'Please enter a valid US phone number'
      }
    }
    return null
  }

  transitCardErrors ($form) {
    const validatedField = $form.find('.validatedTransitCardField')
    if (validatedField.length) {
      if (validatedField.val().match(/\d/g).length < 8) {
        return 'Please enter a valid transit card number'
      }
    }
    if ($form.find('.validatedTransitCardConfirmationField').length) {
      if (
        validatedField.val() !==
        $form.find('.validatedTransitCardConfirmationField').val()
      ) {
        return 'Transit card confirmation does not match'
      }
    }
    return null
  }

  formValidationErrors ($form) {
    // filter(Boolean) removes null elements
    return [
      this.phoneNumberErrors($form),
      this.transitCardErrors($form)
    ].filter(Boolean)
  }

  renderFormErrors ($form, errors) {
    const errorsHtml = errors.map(e => `<li>${e}</li>`).join('')
    $form.find('.formErrors').remove()
    $form.prepend(`<div class="formErrors alert alert-danger collapsed">
      <h4>Please fix these errors:</h4>
      <ul>${errorsHtml}</ul>
    </div>`)
    $form.find('.formErrors').collapse('show')
  }
}
